(function () {
  if (customElements.get('product-item-variants')) return;

  class ProductItemVariants extends HTMLElement {
    constructor() {
      super();
      var productItemVariants = this.querySelectorAll('.product-item__variant');
      var root = this.closest('[data-pcard-root]') || this.closest('.product-item');
      var productLinks = root ? root.querySelectorAll('[data-pcard-link], .product-item__link') : [];
      var productLink = productLinks[0];
      if (!productLink || !root) return;

      var variantZIndex = 9;
      setTimeout(function () {
        var mediaHost = root.querySelector('[data-pcard-media]') || productLink.querySelector('.product-item__image');
        productItemVariants.forEach(function (elm) {
          var variantImageNode = elm.querySelector('.product-item__variant-image');
          if (variantImageNode && mediaHost) {
            mediaHost.appendChild(variantImageNode);
          }
          elm.addEventListener('click', function (e) {
            productItemVariants.forEach(function (item) {
              item.classList.remove('active');
            });
            e.currentTarget.classList.add('active');
            var href = e.currentTarget.dataset.href;
            var varid = e.currentTarget.getAttribute('data-varid');
            if (varid) {
              var idInput = root.querySelector('.item-varid');
              if (idInput) idInput.value = varid;
            }
            productLinks.forEach(function (link) {
              if (href) link.setAttribute('href', href);
            });
            var variantImage = root.querySelector(
              '.product-item__variant-image[data-id="' + e.currentTarget.dataset.id + '"]'
            );
            if (variantImage) {
              variantImage.classList.remove('active');
              variantImage.style.zIndex = ++variantZIndex;
              setTimeout(function () {
                variantImage.classList.add('active');
              }, 10);
            }
          });
        });
      }, 500);
    }
  }

  customElements.define('product-item-variants', ProductItemVariants);
})();
